export default {
  languageName: 'English',
  shortDateFormat: 'DD-MMM-YYYY',
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    menu: 'Menu',
    learn: 'Learn',
    videos: 'Videos',
    aboutTitle: 'About',
    aboutThisSite: 'About This Site',
    whyChezNicuHome: 'Why Chez NICU Home',
    faq: 'F.A.Q.',
    faqExpanded: 'Frequently Asked Questions',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    learnTitle: 'Learn',
    chapters: 'Chapters',
    dischargeTitle: 'Discharge',
    pathway: 'Pathway',
    resourcesTitle: 'Resources',
    glossary: 'Glossary',
    citations: 'Citations',
    researchTitle: 'Research',
    researchPage: 'Staff & Studies',
    staff: 'Staff',
    studies: 'Studies',
    accountTitle: 'Account',
    account: 'Account',
    myDashboard: 'My Dashboard',
    myDiary: 'My Diary',
    diary: 'Diary',
    myAskList: 'My Ask List',
    askList: 'Ask List',
    options: 'Settings',
    login: 'Log In',
    logout: 'Log Out',
    copyright:
      'All content is copyright 2019 Chez NICU Home and IWK Health Centre, unless otherwise stated.',
    search: 'Search…',
    changeProfile: 'Change Profile',
    inviteUser: 'Invite User',
    analytics: 'Analytics'
  },
  signUp: {
    firstName: 'First Name',
    lastName: 'Last Name',
    inputEmail: 'Email',
    roomNumber: 'Room # (optional)',
    messageUnauthorized: 'Your session has timed out',
  },
  login: {
    inputEmail: 'Email',
    inputEmailPlaceholder: 'email@example.com',
    inputPassword: 'Password',
    inputPasswordConfirm: 'Confirm Password',
    inputPasswordNew: 'New Password',
    messageAuthRequired: 'Please log in to view this page',
    messageUnauthorized: 'Your session has timed out',
    messageIncorrect: 'E-mail or password is incorrect'
  },
  resetPassword: {
    notFoundMessage3:
      'If you have lost the link sent in your password reset email, you can %{sendPasswordReset}.'
  },
  profile: {
    connect: 'Continue',
    manageProfiles: 'Manage Profiles',
    addProfile: 'Add a New Profile',
    addProfileTitle: 'Add Profile',
    editProfileTitle: 'Edit Profile',
    editButton: 'Edit Profile',
    done: 'Done',
    selectTitle: 'Select Your Profile',
    manageTitle: 'Manage Profiles',
    welcomeTitle: 'Welcome to IWK Chez NICU Home',
    yourProfileLabel: 'Your Profile',
    firstNameLabel: 'First Name',
    firstNamePlaceholder: 'Your first name',
    lastNameLabel: 'Last Name',
    lastNamePlaceholder: 'Your last name',
    roleLabel: 'Role',
    rolePlaceholder: 'Select a Role',
    roleOtherPlaceholder: 'Your role',
    roleOtherFillInBelow: '(fill in below)',
    iconLabel: 'Select a Profile Icon',
    save: 'Save',
    delete: 'Delete',
    deleteConfirmation: 'Are you sure you want to delete this profile?',
    deleteWarning: 'This action cannot be undone.',
    deleteCancel: 'No, take me back',
    deleteConfirm: 'Yes, delete this profile',
    deleteCurrentMessage: 'You cannot delete your currently selected profile.',
    deleteCurrentCancel: 'Take me back',
    formErrorMessage:
      'Unable to save profile. Make sure all the profile fields are filled out.',
    profileOtherFillInBelow: 'Other (fill in below)'
  },
  dashboard: {
    title: 'Dashboard',
    activities: 'Activities',
    activity: 'Activity',
    sleep: 'Sleep',
    dietDiaper: 'Diet & Diaper',
    milestones: 'Milestones',
    askList: 'Ask List',
    diary: 'Diary',
    growth: 'Growth',
    weight: 'Weight',
    length: 'Length',
    head: 'Head',
    tracking: 'Tracking',
    viewTracking: 'View stats and progress.',
    startTracking: 'Start Tracking',
    startTrackingDesc: 'Start tracking your baby\'s activities, growth, etc. You can track an activity any time from the menu.',
    getStarted: 'Get Started',
    dateAtTime: '%{date} at %{time}',
    noEntries: 'You do not have any entries yet.',
    noEntriesAdd: 'Add your first one.',
    errorCreatingRecord: 'There was an error creating the record.',
    errorEditingRecord: 'There was an error saving the record.',
    errorDeletingRecord: 'There was an error deleting the record.'
  },
  home: {
    welcome: 'Welcome',
    heroTitle: 'You are the most important person to your baby.',
    heroDesc:
      'Research tells us that babies have better outcomes in the NICU when parents have the opportunity to be active participants in care, even in the simplest ways.',
    knowledgeAndTools:
      'Chez NICU Home will give you and your family the knowledge and tools be confident and important partners with your baby’s care team.',
    participate: 'Participate',
    participateSubtitle:
      'Be involved in care that benefits both you and your baby.',
    learn: 'Learn',
    learnSubtitle:
      'Build your confidence and learn new skills at your own pace.',
    contribute: 'Contribute',
    contributeSubtitle:
      'Join us! Together we can engage parents as partners in care.',
    inspireConnectSupport:
      'Chez NICU Home has been created to inspire, connect and support you through your NICU experience.',
    secureWebBased:
      'Chez NICU Home is a secure, web-based, e-learning platform developed by a team of parents, clinicians and scientists to enhance and improve the care we provide to our smallest and most vulnerable patients—our precious NICU babies.'
  },
  tos: {
    title: 'Consent to Create Account and to the Collection and Use of Personal Information',
    acceptButton: `I agree, let\'s make my account`,
    declineButton: 'I do not agree and do not wish to create an account at this time',
    'text:markdown': `## Using the Chez NICU Home website ("CNH Website")

The CNH Website is accessed through the internet and information collected through the CNH Website is stored on secure Amazon servers located in Canada.

If you create a user account to use the CNH Website ("Your Account"), you will be entering information about yourself and/or your family and/or your baby(ies).

The information you enter is only accessible to authorized care providers at your healthcare facility, staff and third-party contractors of the IWK Health Centre who support the technical operation of the CNH Website ("CNH Website Administrators"), and users of other family accounts which you choose to link to your user profile.

## What information about me is collected?

To setup Your Account, CNH Website Administrators need to know a bit about you including your email address 
and what healthcare facility you are at.

Once you are using Your Account, you can choose what information you enter on the CNH Website. You can enter 
information about your baby including name and date of birth. You can choose to track your baby’s growth, 
activities, and milestones. You can also log questions you have or use a diary.

**It is always your choice about how you wish to use the CNH Website and what information you want to enter!

## Who can see my personal information?

That depends on you and what information you choose to share.

Your healthcare providers with authorized access to the CNH Website will be able to see if you have created Your Account and how you are progressing on completing the Discharge Modules.

No other information from the CNH Website will be accessible to your healthcare team. Any information from your Account that you wish for your healthcare team to have, you can discuss with them directly.

If you have other linked family accounts, i.e. aunts or grandparents, those users will be able to see your baby’s milestones and activities.

If you choose to use the Diary as part of Your Account, you can choose to make the Diary private by creating a 4-digit passcode and no other users will be able to access the content of your Diary.

CNH Website Administrators are able to access Your Account, but this is done only for the purpose of ensuring that the CNH Website is working and can be maintained, including creating back-ups of information you choose to add to your Account.

## How is my information used?

The purpose of the CNH Website is to help you care for your baby and give you useful tools to help make your NICU experience as positive as possible!

The information you enter is primarily available to you for your use as you choose.

Your care team will use the information about Your Account activation and your progress through the Discharge Modules to help provide you with better care. For more information on how personal health information is used, please visit the Privacy Policy section of the CNH Website [https://iwk.cheznicuhome.com/subpage/privacy-and-confidentiality](https://iwk.cheznicuhome.com/subpage/privacy-and-confidentiality).

The CNH Website Administrators may also use information you add to Your Account to help improve the Chez NICU Home platform and address issues with use of the CNH Website you might identify. CNH Website Administrators may also contact you by email with information and updates about the use of the CNH Website or your Account, or to request insights and information from you about your use of the CNH Website.

Your information will only be disclosed to third parties as you permit or as permitted or required by law.

## How long is my information kept?

Unless we otherwise advise you, your Account and all associated information will be deleted two years after creation. You can request to delete your account or delete most entries in your account at any time.

## Surveys, Analytics and Cookies

As part of your use of the CNH Website, you may be asked to answer questions or surveys about the content and your use of the Website. You can always choose not to answer. If you do provide this information, it is accessible only to CNH Website Administrators and it will not be shared with anyone else in a way that identifies you.

The CNH Website also tracks your use of the CNH Website through cookies. Cookies are small text files that are placed on your device by the websites that you visit. The IWK and its service providers use targeting and tracking cookies to understand and improve the use of the CNH Website.

The CNH Website also uses Google Analytics, a service which transmits website traffic data to Google servers which may be located outside of Canada. Google Analytics does not identify individual users or associate your information with any other data held by Google.

We use surveys, cookies, and analytics reports to help us understand the use of the CNH Website so we can improve its use for you and other users. We may also use this information for general research and reporting purposes, but never in a way that identifies you.

We do not share any Account information with advertisers and you will not receive advertisements or marketing communications during, or because of, your use of the CNH Website.

## What if I change my mind about consenting to the collection and use of my information?

Most of the information that you enter including questions you log and your baby’s tracked events/activities can be deleted directly by you. If an entry is deleted, a copy will not be kept for more than 24 hours. 

You can withdraw your consent and ask to have your Account and information deleted at any time by sending an email to [cheznicuhome@iwk.nshealth.ca](mailto:cheznicuhome@iwk.nshealth.ca)

Once your Account is deleted, you will no longer have access to the content and features of the CNH Website.

## What if I have questions about my information?

For more information on how the IWK collects, uses and protects personal information, please visit us at [http://www.iwk.nshealth.ca/your-visit/patient-safety/privacy-and-confidentiality](http://www.iwk.nshealth.ca/your-visit/patient-safety/privacy-and-confidentiality). Any questions or concerns, please contact our Privacy Office at
Local: [(902) 470-6309](tel:19024706309)
Toll-free: [1-855-678-9811](tel:18556789811)
Email: [privacy@iwk.nshealth.ca](mailtoprivacy@iwk.nshealth.ca)

Or you can contact the Privacy office at the healthcare facility where you are receiving care.

## Technology and Security

You can access Your Account from any device or location that has an internet connection. You may also use other technology to support your NICU journey such as using communications technology provided by your health centre (where applicable). This can be very helpful in helping you feel supported during your NICU stay. It is not possible, however, for your healthcare facility or the providers of the CNH Website to guarantee the security of technology, devices, or telecommunications tools that you may choose to use. Although we try to minimize any risks, there is always a possibility that someone might be able to access Your Account or your connection to the CNH Website. 

We encourage you to choose a unique, strong password and to only access CNH Website from secure internet connections that you trust. Logout when you are not using your Account. To protect your information, do not to share or post your Account information or password.

## Consent

By creating an account with us, you agree that we may use your information as described above. You also accept the risks that we mention above. You also agree to accept and comply with the Terms of Service posted to the CNH Website [https://iwk.cheznicuhome.com/subpage/terms-of-service](https://iwk.cheznicuhome.com/subpage/terms-of-service). If you have any questions or concerns, please talk to your healthcare team before creating your account or email us at cheznicuhome@iwk.nshealth.ca for more information.

You understand you are freely agreeing to use and are in no way obligated to use the CNH Website as part of receiving your healthcare services
  `},
  privacy: {
    title: 'Privacy and Confidentiality',
    'text:markdown': `## IWK and your Personal Health Information

At the IWK, we are committed to protecting the privacy of your personal health information. We collect, use and disclose the personal health information you entrust to us for a number of purposes, which we summarize in this poster. Our employees and other authorized persons are only allowed to collect, use and disclose the personal health information they need to: (1) fulfill their roles and (2) for purposes permitted under Nova Scotia law, in particular the Personal Health information Act (PHIA).
Collection of Personal Health Information

## The personal health information collected by the IWK may include:

* Your name
* Address
* Date of birth
* Health history
* Provincial health card number
* Other information about the tests, procedures and care you received.

We collect personal health information directly from you or the person acting on your behalf. Sometimes we ask other health professionals or health care organizations involved in your care for your personal health information. This helps us to provide care. The IWK may collect personal health information from other sources, if the law allows, or with your consent. We may collect and store personal health information in different ways - such as your paper chart, electronic files and images.

## Uses and Disclosures of Personal Health Information

We use and disclose your personal health information in order to:

* Treat and care for you during your stay.
* Help other health professionals outside our organization who are involved in your care to provide health services to you. For example, this could include your family doctor, pharmacist, public health nurse, physiotherapist, etc.
* Receive payment from your provincial health care plan, private insurer, or other body for delivering care to you.
* Support the IWK’s educational activities, as we are a teaching hospital.
* Conduct quality improvement and risk management activities.
* Conduct patient satisfaction surveys.
* Conduct research, if you give your express consent. Note: With Research Ethics Board review and approval to protect your privacy and legislation such as PHIA, your personal health information can be used for research without your consent only if strict procedures are in place to make sure that information is anonymous.
* Let your family and friends know that you are in hospital, your room and telephone extension, and general condition (for example, fair, good) on the day they request the information.
* Ask a representative of a faith group (such as a spiritual leader) to visit you during your stay, if you identify this group.
* Plan and manage our internal operations: for example, bed management, staff scheduling.
* Enable the Department of Health and Wellness to plan and manage the health care system.
* Fulfill other purposes permitted or required by law: for example, reporting abuse, reporting communicable diseases.

## Your Rights

You have the right to:

* Request a copy of your personal health information; complete attached [Release of Information Authorization Form](http://www.iwk.nshealth.ca/sites/default/files/FINAL_ROI_Authorization_Form.pdf) subject to [Fee Schedule](http://www.iwk.nshealth.ca/sites/default/files/FEE_SCHEDULE.pdf)
* Request a correction be made;
* Request a record of who has accessed your personal health information in an electronic information system;
* Be advised of a breach of your personal health information;
* Make a complaint about a concern related to your privacy (complete attached [Complaint Form](http://www.iwk.nshealth.ca/sites/default/files/FINAL_-_Complaint_Form.pdf)); and
* Request a review by the Provincial Review Officer of the IWK’s decisions or actions.

You may choose not to give your consent for us to use and disclose your personal health information. We will do what we reasonably can to comply with your wishes. If you ask us, we will not do the following with your personal health information:

* Not give it out to confirm your status as a patient. As soon as you are admitted to hospital, please tell staff working in your unit or department that you want us to keep it private (from friends or family) that you are a patient here.
* Not disclose it to a specific health professional or to another health organization involved in your care.
* Not use it for IWK educational activities or patient satisfaction surveys.
* Not notify a religious representative.

## For More Information

For more information about your rights in relation to your personal health information, please speak to your care team or refer to our privacy pamphlet, ["The Personal Health Information Act" (PL-0807)](http://www.iwk.nshealth.ca/sites/default/files/PL-0807-Final-BROCHURE-May30-2013.pdf)

You may contact the IWK Privacy Office:

> Local: [(902) 470-6309](tel:902-470-6309)${'  '}
Toll-free: [1-855-678-9811](tel:1-855-678-9811)${'  '}
Email: [privacy@iwk.nshealth.ca](mailto:privacy@iwk.nshealth.ca)

Please [click here](http://novascotia.ca/dhw/phia/) to view the Personal Health Information Act (via Department of Health and Wellness website).

## Access to Information

### Freedom of Information

The [Freedom of Information and Protection of Privacy Act](http://nslegislature.ca/legc/statutes/freedom%20of%20information%20and%20protection%20of%20privacy.pdf) (FOIPOP) is provincial access and privacy legislation that applies to the IWK Health Centre. FOIPOP establishes a right of access to records in the custody or control of the IWK Health Centre for the purposes of accountability and transparency. FOIPOP balances the right to information with the protection of personal and confidential information.
How to make a FOIPOP Request

To submit a FOIPOP request, complete the [Application for Access to a Record (Form 1)](http://foipop.ns.ca/sites/default/files/forms/FOIPOP%20Forms/Form%201.pdf) with the $5 application fee and send it to:

### Privacy Coordinator

> IWK Health Centre${'  '}
5850/5980 University Avenue${'  '}
PO Box 9700${'  '}
Halifax, NS B3K 6R8`
  },
  about: {
    title: 'About This Site',
    siteDescription:
      'Your virtual connection in the Neonatal Intensive Care Unit',
    platformTagline:
      'This platform is made for you, because parents have power!',
    placeholderImageAlt: 'A placeholder image to be replaced later.',
    markdown1:
      'The people behind Chez NICU Home are the faces you see around you in the NICU: nurses, doctors, researchers, students, parents, hospital staff, and more. This team is focused on you, and on helping to improve NICU experiences around the world.',
    pullQuote1:
      'Research tells us that NICU babies have better outcomes when their parents participate in their care.',
    markdown2:
      'Within the Chez NICU Home platform, there are many features to help inspire, connect, comfort, and support you and your family to become actively involved in your baby’s care.',
    pullQuote2:
      'Taking part in this platform will be important to you and your baby. It will also help future families in the NICU.',
    markdown3:
      'Participating in research now can help improve the outcomes of premature and sick babies in the future. Your input will help to inform the way we provide education to families and care for NICU babies for the better!',
    pullQuote3: 'Parents Have Power!'
  },
  whyChezNicuHome: {
    title: 'The Chez NICU Home Story',
    placeholderImageAlt: 'A placeholder image to be replaced later.',
    markdown1: 'The research and evidence is clear: **Parents have Power!**',
    pullQuote1: 'Parental presence = parents being in the NICU with their baby',
    markdown2: `Research and evidence tells us that parental presence and support is essential for the best outcomes for a baby.

Researchers and hospitals around the world are learning about the positive outcomes from parental presence. As a result, NICUs are changing their design, creating single rooms instead of large shared spaces or open bays, and focusing on new technologies.

While these changes to NICU design are positive in many ways such as privacy and comfort, parents have expressed feeling isolated, and being away from home and other family.`,
    pullQuote2: 'We knew we needed to do more.',
    markdown3:
      'The goal of Chez NICU Home is to innovate health care in the NICU through better parental presence and involvement.',
    markdown4: `## Chez NICU Home is the Solution

Chez NICU Home connects many pieces of care. This interactive connection between parents, clinicians and peers will be easily accessible with the goal of more parental interaction and engagement.

This innovation allows us to make the best use of resources, and to provide more personalized support and individual care for families and babies, for immediate positive outcomes.

This online platform will be available at all times on monitors, smartphones, tablets, and laptops. Chez NICU home will create a social support for families, provide best research and evidence through learning chapters, and allow for parent feedback.
`
  },
  researchStaff: {
    title: 'Research Staff',
    text: `Research Coordinators are available to answer any questions or concerns before you take part in a study or after you agree to take part and are enrolled. You may call or page any of the Research Coordinators listed below Monday to Friday between 8:00AM and 4:00PM.`,
    alannahName: 'Alannah Delahunty-Pike',
    alannahRole: 'Research Coordinator',
    alannahDetails: `* Office: 902-470-7103\n* [alannah.delahunty-pike@iwk.nshealth.ca](mailto:alannah.delahunty-pike@iwk.nshealth.ca)`,
    alannahImageAlt: 'Photo of Alannah Delahunty-Pike',
    joelleName: 'Joelle Monaghan',
    joelleRole: 'Research Coordinator',
    joelleDetails: `* Office: 902-470-2641\n* Pager #3190\n* [joelle.monaghan@iwk.nshealth.ca](mailto:joelle.monaghan@iwk.nshealth.ca)`,
    joelleImageAlt: 'Photo of Joelle Monaghan'
  },
  researchStudies: {
    title: 'Research Studies',
    text: `You may be asked to participate in one of the following studies:

### Atropine Study: Atropine versus No Atropine for Neonatal Intubation

A study looking at medications given prior to intubation.

### Chez NICU Home

A study looking at the amount of time parents are present in the NICU and how they are involved in the care of their babies.

### MOBYDick: Maternal Omega-3 supplementation to reduce Bronchopulmonary Dysplasia in very preterm infants.

A study looking at the effect of maternal omega-3 supplementation on preterm infant BPD.

### SPiN: Sucrose Practices for Pain in Neonates

A study looking at the effectiveness of repeated sucrose doses, infant response to sucrose administration, and the effect of sucrose on infant outcomes.

### HiPpo: Hemodynamics, Perfusion and Oxygenation Study

The HiPpo Study looks at the effect some commonly used medications have on blood flow in the brain and heart of preterm infants in the NICU. The three medications being studied are fentanyl, acetaminophen (Tylenol) and furosemide.`
  },
  learn: {
    title: 'Learn',
    subtitle: 'What would you like to learn about?',
    references: 'References'
  },
  moduleCard: {
    module: 'Chapter',
    start: 'Let’s Go!',
    review: 'Review',
    continue: 'Continue',
    comingSoon: 'Coming Soon'
  },
  reviewCard: {
    reviewButton: 'Review Chapter'
  },
  moduleDetail: {
    learn: 'Learn',
    chapter: 'Chapter',
    lessons: 'Lessons'
  },
  lessonCard: {
    lesson: 'Lesson',
    start: 'Let’s Go!',
    review: 'Review',
    continue: 'Continue'
  },
  moduleIntroPage: {
    chapter: 'Chapter',
    introduction: 'Introduction',
    review: 'Review',
    beginChapter: 'Begin Chapter %{chapterNumber} Lessons',
    back: 'Back',
    next: 'Next'
  },
  lessonPage: {
    back: 'back',
    backTo: 'Back To',
    chapter: 'Chapter',
    lesson: 'Lesson',
    backToPathway: 'Back to Pathway',
    backToChapter: 'Back to Chapter %{chapterNumber}',
    wrongOption: 'Oops, I chose the wrong option!',
    reviewLater: 'Review Lesson Later',
    congratulations: 'Congratulations!'
  },
  buttons: {
    continue: 'Continue',
    back: 'Back'
  },
  askList: {
    askList: 'Ask List',
    noQuestions: 'You do not have any questions yet!',
    noAnsweredQuestions: 'You do not have any answered questions yet!',
    ownersAskList: '%{owner} Ask List',
    question: 'Question',
    questionAbbreviation: 'Q.',
    addedAt: 'Added %{date}',
    markAsAnswered: 'Mark as Answered',
    unanswered: 'Unanswered',
    answered: 'Answered',
    addAQuestion: 'Add a Question',
    addQuestion: 'Add Question',
    prompt: 'What did you want to ask?',
    detailsPrompt: 'Any additional details?',
    currentLocation: 'Your current page:',
    locationPrompt:
      'Would you like in to include your current page with this question for future reference?',
    logIn: 'log in',
    logInMessage: 'Please %{logInLink} to see your Ask List.',
    includeLocation: 'Yes, include my current page',
    recentQuestions: 'Recent Questions',
    seeAllQuestions: 'See All Questions',
    optional: 'Optional',
    edit: 'Edit',
    saveQuestion: 'Save Question',
    editTitle: 'Edit Question',
    addTitle: 'Add a Question'
  },
  baby: {
    name: 'Name',
    age: 'Age',
    sex: 'Sex',
    room: 'Room',
    deliveryType: 'Delivery Type',
    diagnosis: 'Diagnosis',
    correctedAge: 'Corrected Gestational Age',
    dueDate: 'Due Date',
    birthDate: 'Birth Date',
    admissionDate: 'Admission Date',
    optional: 'optional',
    save: 'Save',
    saveContinue: 'Save and Continue',
    back: 'Back',
    addAnotherBaby: 'Add Another Baby',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    edit: 'Edit Baby Info',
    selectAnIcon: 'Select an Icon',
    ageFormat: '%{days}d',
    gestAgeFormat: '%{weeks}w&nbsp;%{days}d',
    dateFormat: 'MMM DD, YYYY'
  },
  diary: {
    ownersDiary: '%{owner} Diary',
    pin: 'Your PIN',
    email: 'Recovery Email',
    addEntry: 'Add an Entry',
    noEntries: 'You do not have any diary entries yet.',
    depressed: 'Depressed',
    sad: 'Sad',
    okay: 'Okay',
    happy: 'Happy'
  },
  diarySetup: {
    title: 'Diary Setup',
    backToDiary: 'Back to My Diary',
    complete: 'Your PIN is ready!',
    pinDescription: 'Please select a 4 digit PIN to protect your privacy.',
    emailDescription:
      'If you forget your PIN, we will send a reset message to this email.',
    start: 'Get Started!'
  },
  diaryLock: {
    pinEntry: 'Please enter your Privacy PIN to access your Diary',
    incorrect: 'The entered PIN is incorrect',
    resetPinDescription: 'Dont remember your PIN?',
    resetPinLink: 'Reset it by email.'
  },
  onboarding: {
    babies: {
      babies: 'babies',
      baby: 'baby',
      babyName: 'Baby %{name}'
    },
    enquire: {
      primary: {
        headline: 'Nice to meet you, '
      },
      secondary: {
        headline: ' has been added!'
      },
      addNow: 'Yes, let’s add them now!',
      addLater: 'No, I’ll do that later.'
    },
    profiles: {
      primary: {
        headline: 'Tell Us About Yourself',
        directions:
          'Before we let you explore the site, we would like to get to know you a little better',
        firstName: 'What Is Your Name?',
        role: 'What Is Your Role?'
      },
      secondary: {
        headline: 'Add a Family Member',
        directions: 'Tell us more about this family member.',
        firstName: 'What Is Their Name?',
        role: 'What Is Their Role?'
      },
      icon: 'Select a Profile Icon'
    },
    tour: {
      yes: 'Yes, tell me more!',
      no: 'No, I’d rather explore.',
      back: 'Back',
      continue: 'Continue'
    },
    continue: 'CONTINUE',
    saveContinue: 'SAVE & CONTINUE'
  },
  time: {
    minute: 'minute',
    minutes: 'minutes'
  },
  tracker: {
    trackActivity: 'Track Activity',
    trackGrowth: 'Track Growth',
    chooseTrackerTitle: 'What would you like to track?',
    trackSleep: 'Track Sleep',
    trackDietDiaper: 'Track Diet & Diaper',
    trackBathing: 'Track Bathing Session',
    trackMilestone: 'Track Milestone',
    chooseMilestone: 'Milestone',
    date: 'Date',
    time: 'Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    chooseProvider: 'Choose Provider…',
    growth: 'Growth',
    comfort: 'Comfort',
    comfortType: 'Comfort Type',
    provider: 'Provider',
    sleep: 'Sleep',
    presence: 'Presence',
    bathing: 'Bathing',
    duration: 'Duration',
    bodyWeight: 'Body Weight',
    bodyLength: 'Body Length',
    headCircumference: 'Head Circumference',
    save: 'Save',
    cancel: 'Cancel',
    saveSession: 'SAVE SESSION',
    saveGrowth: 'SAVE GROWTH',
    visitor: 'Visitor',
    saveEntryTitle: 'Save entry?',
    saveEntryDescription: 'Anytime you track your baby it’s visible to all profiles in your family account.',
    saveEntryCaption: 'Notification only appears until you save your first entry. For more information see the privacy policy.',
    unSavedModalTitle: 'You have unsaved changes.',
    unSavedDescription: 'You will not be able to recover these changes if you discard them.',
    confirmStay: 'No, take me back',
    confirmLeave: 'Yes, close the window',
    deleteTitle: 'Delete entry?',
    deleteDescription: 'Once you delete, it is gone forever.',
    rejectDelete: 'Cancel',
    confirmDelete: 'Delete',
    confirmDiscard: 'Discard',
    growthMissingFields: `Please enter data for at least one of the fields (weight, length, or head circumference).`
  },
  diaryForgot: {
    title: 'Reset Diary PIN',
    description:
      'An email with a reset link can be sent to the recovery email address associated with your profile.',
    button: 'Send Recovery Email',
    sentTitle: 'Email Sent',
    sentDescription:
      'We have sent an email with instructions on how to reset your Diary PIN.',
    sentDelay: 'Please note it can take up to 30 minutes to arrive.',
    failureDescription:
      'We were unable to send a recovery email. Please try again later.'
  },
  diaryReset: {
    title: 'Reset Your Diary PIN',
    pin: 'Your New PIN',
    reset: 'Reset PIN',
    failure: 'Unable to reset diary PIN',
    successTitle: 'Diary PIN Reset!',
    successDescription:
      'You have successfully changed your diary PIN! You can now use it to access your diary.',
    goToDiary: 'Go to Diary'
  },
  diaryEditor: {
    editTitle: 'Edit Diary Entry',
    createTitle: 'Add a Diary Entry',
    feelingLabel: 'How are you feeling today?',
    contentLabel: 'What’s on your mind?',
    hiddenLabel: 'Hide this entry',
    hiddenNote:
      'Hiding a diary entry will hide the contents on the Diary screen for additional privacy and exclude the contents from research data collection.',
    save: 'SAVE ENTRY',
    optional: 'Optional'
  },
  diaryEntryView: {
    hideEntry: 'Hide Entry',
    showEntry: 'Show Entry',
    editEntry: 'Edit this Entry',

    postedAt: 'Posted at %{time}',
    hidden: 'Private',
    feeling: 'Feeling:'
  },
  discharge: {
    dischargePathway: 'Discharge Pathway',
    beginYourJourney: 'Begin Your Journey',
    continueYourJourney: 'Continue Your Journey',
    whatLearnAbout: 'What would you like to learn about?',
    notStarted: 'Not Yet Started',
    complete: 'Complete',
    inProgress: 'In Progress',
    continueThisLesson: 'Continue this Lesson',
    reviewThisLesson: 'Review this Lesson',
    beginThisLesson: 'Begin this Lesson',
    lessonComplete: 'Lesson Complete!',
    partialHomeTitle: 'You are doing a great job!',
    partialHomeSubTitle: 'You and your family are on your way!',
    youHaveCompleted:
      'You have completed **%{numComplete}** of **%{numTotal}** lessons.',
    keepGoing: 'Keep going!',
    youMadeIt: 'You Made it!',
    nowYouCanReview: 'Now you can review the lessons whenever you like.',
    congrats: 'Congratulations!',
    youveCompletedYourPathway: 'You have completed your pathway.',
    youreReadyToGoHome: 'Talk to your nurse about going home.'
  },
  accountOptions: {
    title: 'Account Options',
    account: 'Account',
    profiles: 'Profiles',
    babies: 'Babies',
    privacy: 'Privacy',
    editAccountInfo: 'Edit Account Information',
    goBack: 'Go Back',
    yourEmailChanged: 'Your Email Has Been Changed!',
    yourEmailChangedText:
      'You can now use this email address to sign into your account.',
    yourPasswordChanged: 'Your Password Has Been Changed!',
    yourPasswordChangedText:
      'You can now use this password to sign into your account. Please notify your other family members as they will need it to access this account.',
    accountEmailAddress: 'Account Email Address',
    confirmAccountEmailAddress: 'Confirm Account Email Address',
    currentPassword: 'Current Password',
    editEmail: 'Edit Email',
    emailConfirmError: 'Emails must match.',
    incorrectPassword: 'This password is incorrect.',
    incorrectPin: 'This PIN is incorrect.',
    pinConfirmError: 'This must match the above PIN.',
    accountPassword: 'Account Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    change: 'Change',
    reset: 'Reset',
    cancel: 'Cancel',
    save: 'Save',
    manageBabyProfiles: 'Manage Baby Profiles',
    addBaby: 'Add a New Baby',
    addBabyError: 'There was an error adding this baby.',
    editBabyError: 'There was an error editing this baby.',
    privacyGreeting: 'Hello, %{name}!',
    privacyDescription:
      'These are the privacy options for your individual profile.',
    privacyNotUser: 'Not %{name}?',
    privacyChangeProfile: 'Change Your Profile',
    diaryPrivacy: 'Diary Privacy',
    diaryPrivacyInformation: 'Diary Privacy Information',
    editYourEmail: 'Edit Your Email',
    recoveryEmailAddress: 'Recovery Email Address',
    confirmRecoveryEmailAddress: 'Confirm Recovery Email Address',
    currentDiaryPin: 'Current Diary PIN',
    errorSettingRecoveryEmail: 'There was an error setting the recovery email.',
    errorSettingPin: 'There was an error setting the PIN.',
    yourRecoveryEmailChanged: 'Your recovery email has been changed!',
    yourRecoveryEmailChangedText:
      'If you forget your PIN you will be able to send a reset email to your new recovery email.',
    diaryPin: 'Diary PIN',
    newDiaryPin: 'New Diary PIN',
    confirmNewDiaryPin: 'Confirm New Diary PIN',
    required: 'This field is required.',
    yourPinChanged: 'Your PIN has been changed!',
    yourPinChangedText:
      'You can now use this PIN to access your diary. Be sure to keep this PIN secure – it is for your eyes only!',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyText:
      'Your privacy is important to us! We suggest you review our privacy policy.',
    readThePrivacyPolicy: 'Read the Privacy Policy',
    passwordRequirements: {
      notEmpty: 'Password is required.',
      minimumChars: 'Password must be 8 or more characters.',
      uppercase: 'Password must have at least 1 uppercase character.',
      specialChar: 'Password must have at least 1 special character.',
      match: 'Your passwords do not match.'
    }
  },
  validation: {
    emailAddress: 'Emails must have both an @ and domain (e.g. .com)',
    required: 'This field is required.'
  },
  invite: {
    title: 'Invite User',
    description:
      'Enter an email below and we will send them a link for setting up an account on Chez NICU Home.',
    emailLabel: 'Email',
    emailPlaceholder: 'user@example.com',
    researchIdLabel: 'Research ID',
    researchIdPlaceholder: 'Required…',
    button: 'Send Invite',
    duplicateEmail: 'The provided email already has an account on the system',
    duplicateResearchId: 'The provided research ID is already in use',
    successTitle: 'Invite Sent!',
    successDescription1:
      'We have just sent an email with a link for setting up an account on Chez NICU Home.',
    successDescription2:
      'Please note that it can take up up to 30 minutes to arrive.'
  },
  roles: {
    mother: 'Mother',
    father: 'Father',
    sibling: 'Sibling',
    grandmother: 'Grandmother',
    grandfather: 'Grandfather',
    aunt: 'Aunt',
    uncle: 'Uncle',
    godmother: 'Godmother',
    godfather: 'Godfather',
    nanny: 'Nanny',
    familyFriend: 'Family Friend',
    coworker: 'Coworker',
    other: 'Other'
  },
  comfortTypes: {
    'skin-to-skin-care': 'Skin-to-Skin Care',
    breastfeeding: 'Breastfeeding',
    singing: 'Singing',
    holding: 'Holding',
    reading: 'Reading',
    other: 'Other (fill in below)'
  },
  helpToolTip: {
    label: 'More information'
  },
  modal: {
    close: 'Close'
  },
  table: {
    edit: 'Edit this item',
    delete: 'Delete this item'
  },
  evidenceButton: {
    title: 'More information'
  },
  glossary: {
    backToTop: 'Back to top'
  },
  analytics: {
    discharge: 'Discharge Account',
    download: 'Download User Data',
    ridLabel: 'Research ID',
    statusLabel: 'Status',
    waitingStatus: 'Awaiting Discharge…',
    dischargedStatus: 'Discharged'
  }
};



// WEBPACK FOOTER //
// ./src/translations/en-CA.js